<template>
	<b-navbar toggleable="md" :type="type" variant="secondary">
		<b-nav-toggle target="nav_collapse"></b-nav-toggle>

		<b-navbar-brand href="#">{{ descricao.toUpperCase() }}</b-navbar-brand>

    <header-campanha :campanha="campanha"></header-campanha>

    <b-collapse is-nav id="nav_collapse">

      <b-navbar-nav >
        <!-- Links is here -->
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">

        <b-nav-item-dropdown :text="username" left>
          <b-dropdown-item @click="logoff()">Sair</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item href="#" class="active" @click="logoff()">SAIR</b-nav-item>

      </b-navbar-nav>
    </b-collapse>

	</b-navbar>
</template>
<style >
a > span {
  color: #fff;
}
</style>

<script>
import HeaderCampanha from "./HeaderCampanha.vue";

import { mapState } from "vuex";

export default {
  name: "NavBar",

  components: {
    HeaderCampanha
  },

  props: ["type"],

  data() {
    return {};
  },

  computed: {
    ...mapState({

      username: state => {
        let userName = state.user.nome || "";
        let matricula = state.user.matricula || "";

        userName = userName.trim().split(" ");
        userName = `${userName[0]} ${userName[userName.length - 1]}`;

        if (matricula) matricula = `(${matricula})`;

        return `${userName} ${matricula}`;
      },

      campanha: state => state.user.campanha,

      descricao: state => state.user.descricao,

      getUser: state => state.user

   }),

    hasContact() {
      return this.$store.getters.hasContact;
    },

    hasIntegration() {
      return this.$store.getters.hasIntegration;
    }
  },

  methods: {
    logoff() {
      if (this.hasContact && (this.hasIntegration && this.getUser.tipoDiscagem !== "MANUAL")) {
        this.$alert(
          "Tabule o contato antes de sair do sistema.",
          "TABULAR CONTATO",
          {
            confirmButtonText: "OK"
          }
        );
      } else {
        this.$bus.$emit("exit", {});
        this.$store.commit("removeAllContacts", []);

        this.$store.commit("setUser", {});
        this.$router.push("/");
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// NavBar.vue?492502a6